import React from "react";
import { Box, Typography } from "@mui/material";

export const ChatIntroduction = () => (
  <Box sx={{ textAlign: "center", py: 4, px: 2 }}>
    <Typography variant="h6" gutterBottom>
      👋 Hi, I'm Bud!
    </Typography>
    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
      I can help you analyse your class data and answer questions about:
    </Typography>
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 3 }}>
      <Typography variant="body2">📊 Student performance and scores</Typography>
      <Typography variant="body2">
        📈 Assignment and question analytics
      </Typography>
      <Typography variant="body2">
        🎯 Identifying struggling students
      </Typography>
      <Typography variant="body2">📉 Tracking trends over time</Typography>
    </Box>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Try one of the suggestions below, or ask me anything!
    </Typography>
    <Typography variant="caption" color="text.secondary">
      Note: I can only answer questions about your class data. I cannot help
      with general teaching advice or non-data questions.
    </Typography>
  </Box>
);
